// Imports
import AxiosConfig from '../config/AxiosConfig'

const sendEmailVerification = async (toEmail) => {
  const { data } = await AxiosConfig.post('/sendEmailVerification', {
    toEmail
  })

  return data
}

const sendPasswordReset = async (toEmail) => {
  const { data } = await AxiosConfig.post('/sendPasswordReset', {
    toEmail
  })

  return data
}

export default {
  sendEmailVerification,
  sendPasswordReset
}